import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "CategorySort" }
const _hoisted_2 = {
  key: 0,
  class: "CategorySort-links"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "CategorySort-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_ctx.sort)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sort.available, (sortBtn) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass({ 'CategorySort-link': true, 'is-active': sortBtn.value === _ctx.sort.selected }),
              key: sortBtn.value,
              onClick: ($event: any) => (_ctx.sortProduct(sortBtn.value)),
              type: "button"
            }, _toDisplayString(sortBtn.label), 11, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.productCount) + " produktů ", 1)
  ]))
}